import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'contexts/ThemeContext';

import moment from 'utils/moment';

import { Text } from 'components/DataDisplay';
import { Container } from 'components/Layout';

import { PendingChangeDiff } from './PendingChangeDiff';
import { PendingChangeLine } from './PendingChangeLine';

export const RecapNameChange = ({ nameChange }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;
  const { upsertLabel, requestedAt } = nameChange;
  const requestedLabel = moment(requestedAt).isValid()
    ? ` — demandé le ${moment(requestedAt).format('D MMM')}`
    : '';

  return (
    <Container
      flex
      style={{
        width: '100%',
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: '8px',
        backgroundColor: designSystem.violetBg,
        border: `1px solid ${designSystem.violet}`,
        borderRadius: '9px',
        padding: '10px 12px',
        marginBottom: '12px'
      }}
    >
      <Text
        component="span"
        fontSize="11.5px"
        fontWeight={700}
        style={{ color: designSystem.violet }}
      >
        Modification en attente
        {upsertLabel ? ` · ${upsertLabel}` : ''}
        {requestedLabel}
      </Text>
      <PendingChangeLine label="Nom de la campagne">
        <PendingChangeDiff diff={nameChange} />
      </PendingChangeLine>
    </Container>
  );
};

RecapNameChange.propTypes = {
  nameChange: PropTypes.shape().isRequired
};

export default RecapNameChange;
